/* ============================================
   GH NEWSLETTER POPUP SCRIPT v7
============================================ */
(function() {
  const popup = document.getElementById('ghNlPopup');
  const step1 = document.getElementById('ghNlStep1');
  const step2 = document.getElementById('ghNlStep2');
  const step3 = document.getElementById('ghNlStep3');
  const nextBtn = document.getElementById('ghNlNext');
  const form = document.getElementById('ghNlForm');
  
  if (!popup) return;

  const SESSION_KEY = 'gh_nl_popup_shown';
  let hasTriggered = false;

  // Sektioner att blurra
  var sectionsToBlur = [
    '#gh-landing-hero',
    '#gh-landing-hook',
    '#gh-landing-profil',
    '#gh-landing-products',
    '#gh-landing-insights',
    '#gh-landing-close'
  ];

  /* SESSION CHECK */
  function alreadyShown() {
    return sessionStorage.getItem(SESSION_KEY) === 'true';
  }

  function markAsShown() {
    sessionStorage.setItem(SESSION_KEY, 'true');
  }

  /* BLUR CONTROL */
  function addBlur() {
    sectionsToBlur.forEach(selector => {
      const el = document.querySelector(selector);
      if (el) el.classList.add('gh-blur');
    });
  }

  function removeBlur() {
    sectionsToBlur.forEach(selector => {
      const el = document.querySelector(selector);
      if (el) el.classList.remove('gh-blur');
    });
  }

  /* OPEN/CLOSE */
  function openPopup() {
    if (alreadyShown() || hasTriggered) return;
    hasTriggered = true;
    markAsShown();
    
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gh-nl-open');
    addBlur();
  }

  function closePopup() {
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gh-nl-open');
    removeBlur();
  }

  /* STEP NAVIGATION */
  function goToStep(stepNum) {
    step1.hidden = stepNum !== 1;
    step2.hidden = stepNum !== 2;
    step3.hidden = stepNum !== 3;

    if (stepNum === 2) {
      setTimeout(() => {
        document.getElementById('ghNlFirstName')?.focus();
      }, 100);
    }

    if (stepNum === 3) {
      setTimeout(closePopup, 3000);
    }
  }

  /* SCROLL TRIGGER – fires after products section (user has seen health profile promo + products) */
  function checkScrollPosition() {
    if (hasTriggered || alreadyShown()) return;

    var productsSection = document.getElementById('gh-landing-products');
    if (!productsSection) return;

    var productsBottom = productsSection.getBoundingClientRect().bottom;
    var viewportHeight = window.innerHeight;

    // Trigger when products section is mostly scrolled past
    if (productsBottom < viewportHeight * 0.3) {
      openPopup();
    }
  }

  /* EVENT LISTENERS */
  window.addEventListener('scroll', checkScrollPosition, { passive: true });

  document.querySelectorAll('[data-gh-close-nl]').forEach(el => {
    el.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
      closePopup();
    }
  });

  // Step 1 → Step 2
  nextBtn?.addEventListener('click', () => goToStep(2));

  /* FORM SUBMIT */
  form?.addEventListener('submit', async (e) => {
    e.preventDefault();

    const firstName = document.getElementById('ghNlFirstName');
    const lastName = document.getElementById('ghNlLastName');
    const email = document.getElementById('ghNlEmail');
    const submitBtn = document.getElementById('ghNlSubmit');
    const btnText = submitBtn.querySelector('.gh-nl-popup__btn-text');
    const btnLoading = submitBtn.querySelector('.gh-nl-popup__btn-loading');
    const errorEl = document.getElementById('ghNlError');

    // Clear errors
    [firstName, lastName, email].forEach(el => el.classList.remove('gh-nl-popup__input--error'));
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    // Validate
    let hasError = false;
    if (!firstName.value.trim()) {
      firstName.classList.add('gh-nl-popup__input--error');
      hasError = true;
    }
    if (!lastName.value.trim()) {
      lastName.classList.add('gh-nl-popup__input--error');
      hasError = true;
    }
    if (!email.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
      email.classList.add('gh-nl-popup__input--error');
      hasError = true;
    }

    if (hasError) return;

    // Loading state
    submitBtn.disabled = true;
    btnText.hidden = true;
    btnLoading.hidden = false;

    // OVISST ÄR DEFAULT: kvitterad sätts i samma sats som utfallet avgörs och läses FÖRST i felgrenen.
    var kvitterad = false;
    var renderfel = false;
    var oviss = true;
    var serverText = '';

    // TIDSGRÄNSEN BITER UTAN AbortController: kapplöpningen är mekanismen, avbrottet bara en bonus.
    var nlAbort = (typeof AbortController === 'function') ? new AbortController() : null;
    var nlTimeout = null;
    var nlTak = new Promise(function(_, avvisa) {
      nlTimeout = setTimeout(function() {
        if (nlAbort) nlAbort.abort();
        avvisa(new Error('nl_unknown'));
      }, 15000);
    });

    try {
      // RACET OMFATTAR HELA KEDJAN, fetch OCH kroppsläsningen: annars settlar det redan vid svarshuvudena.
      var svar = await Promise.race([
        fetch('/apps/gh/newsletter-signup', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          signal: nlAbort ? nlAbort.signal : undefined,
          body: JSON.stringify({
            email: email.value.trim(),
            firstName: firstName.value.trim(),
            lastName: lastName.value.trim()
          })
        }).then(function(r) {
          return r.json().then(function(d) { return { data: d, status: r.status }; },
            function() { throw new Error('nl_unknown'); });
        }),
        nlTak
      ]);

      var res = { status: svar.status };
      var data = svar.data;
      serverText = (data && data.error) || '';

      // BOOLEAN-STRIKT, ingen truthiness. Workern svarar ALDRIG 2xx på ett
      // avslag, så ett 2xx utan success === true är OKÄNT, aldrig misslyckat.
      if (res.status < 300 && data && data.success === true) {
        kvitterad = true;
        oviss = false;
        goToStep(3);
      } else if (data && data.partial === true) {
        // Något ligger redan i Shopify: ovisst kvarstår och beskedet ber om
        // omladdning i stället för en ny anmälan.
        throw new Error('nl_unknown');
      } else if (res.status >= 400 && res.status < 500) {
        // 4xx utan committat steg: ingenting hände, kunden kan rätta och skicka
        // igen.
        oviss = false;
        throw new Error('nl_rejected');
      } else {
        throw new Error('nl_unknown');
      }

    } catch (err) {
      // KVITTERAD LÄSES FÖRST: allt som kastar härefter är visning.
      if (kvitterad) {
        renderfel = true;
        if (errorEl) {
          errorEl.textContent = 'Din anmälan är registrerad, men sidan kunde inte uppdateras. Ladda om sidan.';
          errorEl.hidden = false;
        }
      } else {
        console.error('Newsletter signup error:', err);
        // WORKERNS TEXT VISAS när den finns; annars en svensk text som följer
        // verdiktet. Ingen browsertext ut i gränssnittet.
        if (errorEl) {
          errorEl.textContent = serverText || (err && err.message === 'nl_rejected'
            ? 'Vi kunde inte skicka din anmälan just nu. Försök igen om en stund.'
            : 'Vi vet inte om din anmälan gick igenom. Ladda om sidan och kontrollera innan du försöker igen.');
          errorEl.hidden = false;
        }
      }
    } finally {
      clearTimeout(nlTimeout);
      btnText.hidden = false;
      btnLoading.hidden = true;
      // Låst tills omladdning vid ovisst utfall OCH vid renderfel efter kvittens.
      if (!oviss && !renderfel) submitBtn.disabled = false;
    }
  });

  /* INITIAL CHECK */
  setTimeout(checkScrollPosition, 500);

})();
